import type { InjectableReduxStore } from '@pn/services/redux/configureInjectableStore';
import type { IErrorLogger } from './services/loggers/ports';
import type { IMap } from './services/map/ports';
import type { INotificationService } from './services/notifications/ports';

export type AppName = 'maps' | 'intel' | 'formations' | 'forecast' | 'admin';

/**
 * Runtime values that shared `packages/*` code can't import, set by each app in
 * its `useInitializeApp` hook via `setCoreDependencies`:
 * - `store`, `map` and `appName` differ per app.
 * - `errorLogger` and `notificationService` keep browser-only implementations
 *   out of code that also runs in Node: `handleError` is used by
 *   `servers/stackdx-ai` and unit tests.
 *
 * App code imports its own store and the services directly instead.
 */
export const dependencies = {
  appName: {} as AppName,
  errorLogger: {} as IErrorLogger,
  notificationService: {} as INotificationService,
  map: {} as IMap<mapboxgl.Map>,
  store: {} as InjectableReduxStore,
};

type Deps = Partial<typeof dependencies>;

export const setCoreDependencies = (deps: Deps) => {
  Object.assign(dependencies, deps);
};
